// src/components/AddCompanyForm/IdentityVisualCard.jsx
import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  TextField,
  InputAdornment,
} from "@mui/material";
import ColorizeRoundedIcon from "@mui/icons-material/ColorizeRounded";
import LogoUploader from "./LogoUploader";
import { toHex } from "./utils";
import { useTranslation } from "react-i18next";

/** Slug, cor primária e logo (nome e status ficam em CompanyEssentialsCard). */
export default function IdentityVisualCard({ form, setForm, onBusyUpload }) {
  const set = (patch) => setForm((p) => ({ ...p, ...patch }));
  const { t } = useTranslation("settings");

  return (
    <Card variant="outlined">
      <CardHeader
        title={t("addCompanyForm.identity.visualOnlyTitle")}
        subheader={t("addCompanyForm.identity.visualOnlySubheader")}
      />
      <CardContent sx={{ pt: 0 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label={t("addCompanyForm.identity.slugLabel")}
                  value={form.codigo_interno}
                  onChange={(e) => set({ codigo_interno: e.target.value })}
                  fullWidth
                  placeholder={t("addCompanyForm.identity.slugPlaceholder")}
                  helperText={t("addCompanyForm.identity.slugHelper")}
                  inputProps={{ maxLength: 60 }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  label={t("addCompanyForm.identity.primaryColorLabel")}
                  value={form.primary_color || ""}
                  onChange={(e) => set({ primary_color: e.target.value })}
                  fullWidth
                  placeholder="#1D2B6E"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <input
                          type="color"
                          aria-label={t("addCompanyForm.identity.selectColorAria")}
                          value={toHex(form.primary_color || "") || "#000000"}
                          onChange={(e) => set({ primary_color: toHex(e.target.value) })}
                          style={{ width: 28, height: 28, border: 0, background: "transparent", cursor: "pointer" }}
                        />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <ColorizeRoundedIcon
                          fontSize="small"
                          sx={{ color: toHex(form.primary_color || "") || "text.secondary" }}
                        />
                      </InputAdornment>
                    ),
                  }}
                  helperText={t("addCompanyForm.identity.primaryColorHelper")}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} md={4}>
            <LogoUploader
              value={form.logo || form._logoPreview}
              onChange={(url) => set({ logo: url, _logoPreview: url })}
              onBusyChange={onBusyUpload}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
